import { render } from "./info.vue?vue&type=template&id=78333023"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
script.render = render

export default script